"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_PATH = exports.UPDATE_HISTORY = exports.RESET_IMPRESSONS = exports.PREVENT_IMPRESSIONS_RESET_ON_PAGEVIEW = exports.LOCATION_CHANGE = void 0;
var RESET_IMPRESSONS = 'RESET_IMPRESSONS';
exports.RESET_IMPRESSONS = RESET_IMPRESSONS;
var PREVENT_IMPRESSIONS_RESET_ON_PAGEVIEW = 'PREVENT_IMPRESSIONS_RESET_ON_PAGEVIEW'; // From redux-simple-router

exports.PREVENT_IMPRESSIONS_RESET_ON_PAGEVIEW = PREVENT_IMPRESSIONS_RESET_ON_PAGEVIEW;
var UPDATE_PATH = '@@router/UPDATE_PATH'; // react-router-redux v3

exports.UPDATE_PATH = UPDATE_PATH;
var LOCATION_CHANGE = '@@router/LOCATION_CHANGE'; // react-router-redux v4

exports.LOCATION_CHANGE = LOCATION_CHANGE;
var UPDATE_HISTORY = '@@router/CALL_HISTORY_METHOD';
exports.UPDATE_HISTORY = UPDATE_HISTORY;